module.exports = __webpack_public_path__ + "ClientApp/content/lap-of-love-newsletter.jpg";